import { expiryState } from '../lib/expiry.ts';

// Small read-only status chip for an uploaded file's expiry date. Colour and
// label are derived from the shared expiryState() helper so the warning window
// (EXPIRY_WARNING_DAYS) stays defined in one place.
//
//   expired   → red    "Expired · 12/05/2026"
//   expiring  → amber  "Expires 8/06/2026"
//   ok        → grey   "Expires 30/12/2026"
//   none      → muted  "No expiry date"
export function ExpiryChip({ expiresAt }: { expiresAt: string | null }) {
  const state = expiryState({ expires_at: expiresAt });

  if (state === 'none') {
    return (
      <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-400">
        No expiry date
      </span>
    );
  }

  const date = new Date(expiresAt!).toLocaleDateString();

  if (state === 'expired') {
    return (
      <span className="shrink-0 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700">
        Expired · {date}
      </span>
    );
  }

  if (state === 'expiring') {
    return (
      <span className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
        Expires {date}
      </span>
    );
  }

  return (
    <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
      Expires {date}
    </span>
  );
}
